import React from "react";
import { placeholderImage } from "../lib/image";
import "./HtmlEmbed.style.scss";

export interface HtmlProps {
    html: string;
    schedule: {};
    amp?: boolean;
}

export function replaceImgWithAmpImg(html: string) {
    return html.replace(/<img(?:.|\n)*?>/g, match => {
        const [, height] = /height[:|=][\s|"]?(.*?x{1})/.exec(match) || [null, "225"];
        const [, width] = /width[:|=][\s|"]?(.*?x{1})/.exec(match) || [null, "400"];
        const [, alt] = /alt="(.*?)"/.exec(match) || [null, "Alt Text"];
        const [, src] = /src="(.*?)"/.exec(match) || [null, placeholderImage];

        if (!src) {
            return "";
        }

        return `
            <amp-img
                alt="${alt}"
                src="${src}"
                width="${width}"
                height="${height}"
                layout="responsive"
            >
                <noscript>
                    ${match}
                </noscript>
            </amp-img>
        `;
    });
}

export const HtmlEmbedLegacy = ({ html: __html, amp }: HtmlProps) => {
    if (amp && __html.includes("<img")) {
        __html = replaceImgWithAmpImg(__html);
    }
    return <div className="component-embed-html" dangerouslySetInnerHTML={{ __html }} />;
};

export default HtmlEmbedLegacy;
